import { render, staticRenderFns } from "./CourseTypePage.vue?vue&type=template&id=06feb7ec&scoped=true&"
import script from "./CourseTypePage.vue?vue&type=script&lang=js&"
export * from "./CourseTypePage.vue?vue&type=script&lang=js&"
import style0 from "./CourseTypePage.vue?vue&type=style&index=0&id=06feb7ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06feb7ec",
  null
  
)

export default component.exports